// Pro "Payment received" celebration bus: any screen calls celebratePayment(); one host shows it.
const seen = new Set();
const claimed = new Set();

export function celebratePayment({ key, amount, method = "cash", who } = {}) {
  if (key && seen.has(key)) return;
  if (key) seen.add(key);
  window.dispatchEvent(new CustomEvent("yorm:payment-received", { detail: { amount: Number(amount || 0), method, who } }));
}

export const markCelebrated = (key) => key && seen.add(key);

// A screen that celebrates a job itself (e.g. the trip page's Confirm-payment sheet) claims it while open.
export const claimTarget = (id) => { if (id) claimed.add(id); return () => claimed.delete(id); };
export const isClaimed = (id) => !!id && claimed.has(id);
